import { z } from 'zod';
export const evaluationStatusSchema = z.enum([
    'concept',
    'zelf_klaar',
    'draft',
    'review',
    'definitief',
]);
export const evaluationTypeSchema = z.enum(['self', 'manager']);
export const scoreSchema = z.object({
    taskId: z.number(),
    score: z.number().min(1).max(5),
    toelichting: z.string().optional(),
});
export const createEvaluationSchema = z.object({
    employeeId: z.number(),
    type: evaluationTypeSchema,
    jaar: z.number().min(2020).max(2100),
});
export const updateEvaluationSchema = z.object({
    status: evaluationStatusSchema.optional(),
    scores: z.array(scoreSchema).optional(),
});
export const selfEvaluationSchema = z.object({
    scores: z.array(scoreSchema),
    opmerkingen: z.string().optional(),
});
// Task schemas
export const createTaskSchema = z.object({
    name: z.string().min(1, 'Naam is verplicht'),
    beschrijving: z.string().optional(),
    weging: z.number().min(0).max(100),
    niveauId: z.number(),
});
// Niveau schemas
export const createNiveauSchema = z.object({
    name: z.string().min(1, 'Naam is verplicht'),
    beschrijving: z.string().optional(),
    criteria: z.string().min(1, 'Criteria zijn verplicht'),
});
//# sourceMappingURL=evaluation.js.map